import React, { useState, useEffect } from "react";
import axios from "axios";

import "./blog.css";

export default function Bloglist() {
  const [blogList, setblogList] = useState([]);
  const [loading, setLoading] = useState(0);

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND_URL + "/api/blog")
      .then((response) => {
        //console.log(response.data);
        setblogList(response.data);
        if (response.data.length > 0) {
          setLoading(1);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div>
      {loading == 0 ? (
        <center>
          <div class="BlogNoDataDiv">
            <div
              class="spinner-border text-primary"
              role="status"
              style={{ height: "80px", width: "80px" }}
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </center>
      ) : (
        <div className="row BlogListRow">
          {blogList.map((blogs) => {
            return (
              <div
                className="col-lg-4 col-md-6"
                style={{ marginTop: "8px", padding: "20px" }}
              >
                <a
                  href={blogs.Link}
                  target="_blank"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <div>
                    <div class="card BlogComponent">
                      <img
                        class="card-img-top"
                        src={blogs.ImageUrl}
                        alt="Card image cap"
                        style={{ height: "12rem" }}
                      />
                      <div class="card-body">
                        <h5 class="card-title">{blogs.Title}</h5>
                        <p class="card-text">{blogs.Description}</p>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
